import App, { Container } from "next/app";
import { I18n as I18nR } from "react-i18next";
import i18n from "../i18n";
import React from "react";
import withReduxStore from "../libs/with-redux-store";
import { Provider } from "react-redux";
import Router from "next/router";

class MyApp extends App {
  constructor(props) {
    super(props);

    this.onLoadStorage = this.onLoadStorage.bind(this);
    this.onLoad = this.onLoad.bind(this);
    this.onUnLoad = this.onUnLoad.bind(this);
  }

  //Nattawut Note 39
  componentDidMount() {
  
    const lng = this.getCookie("i18next");
    if(lng==undefined || lng == null || lng=="")
    {
      document.cookie = 'lng=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      document.cookie = 'i18next=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      if(["TETRAPAKUAT","TETRAPAK"].includes(process.env.PROJECT)){
        document.cookie = "i18next=en-US";
      }
      else if (
        ![
          "smtb_test",
          "GOTEST",
          "PIS",
          "PISGOON",
          "SMTB",
          "staybridge",
          "BOOTS"
        ].includes(process.env.PROJECT)
      ) {
        document.cookie = "i18next=th-TH";
      }
    }

    window.addEventListener("storage", this.onLoadStorage, false);
    window.addEventListener("load", this.onLoad);
    window.addEventListener("beforeunload", this.onUnLoad);

  }

  getCookie = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    if(ca.length>0){
      var c = ca[ca.length-1];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    else
      return ""
  };

  componentWillUnmount() {
    window.removeEventListener("storage", this.onLoadStorage);
    window.removeEventListener("load", this.onLoad);
    window.removeEventListener("unload", this.onUnLoad);
  }

  logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("activeMenu");
    localStorage.removeItem("theme");
    Router.push("/login");
  }

  onLoad() {
    const isActiveOnStorage = localStorage.getItem("isActive");
    const isLoad = localStorage.getItem("load");
    const lastTime = localStorage.getItem("lastLime");
    const isRemember = localStorage.getItem("remember");
    const currentTime = new Date().getTime();
    const refreshTime = currentTime - lastTime;
    if (
      refreshTime > 5000 &&
      isActiveOnStorage === "false" &&
      isLoad === "false" &&
      isRemember === "false"
    ) {
      this.logout();
    } else {
      localStorage.setItem("isActive", "true");
      localStorage.setItem("load", "true");
    }
  }

  onUnLoad(e) {
    e.preventDefault();
    localStorage.setItem("lastLime", new Date().getTime());
    localStorage.setItem("isActive", "false");
    localStorage.setItem("load", "false");
    return;
  }

  onLoadStorage() {
    setTimeout(() => {
      const isActiveOnStorage = localStorage.getItem("isActive");
      const isLoad = localStorage.getItem("load");
      if (isActiveOnStorage === "false" && isLoad === "false") {
        localStorage.setItem("isActive", "true");
        localStorage.setItem("load", "true");
      }
    }, 1000);
  }


  render() {
    const { Component, pageProps, reduxStore } = this.props;
    return (
      <Container>
        <Provider store={reduxStore}>
          <I18nR ns="common" i18n={(pageProps && pageProps.i18n) || i18n} wait>
            {(t) => (
              <div>
                <Component {...pageProps} />
              </div>
            )}
          </I18nR>
        </Provider>
      </Container>
    );
  }
}

export default withReduxStore(MyApp);
